var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.domain)?_c('CompanyView',{attrs:{"company-domain":_vm.domain}}):_c('div',{staticClass:"not-a-website"},[_c('img',{attrs:{"src":"/img/logo.png"}}),_c('h2',[_vm._v(" To find company information fast, first browse to a company website then click the extension button again. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }